import { UserSummaryType } from '../../../api/types/user/user-summary.type';
import React, { useState } from 'react';
import { StudentSideBarItemType } from '../../../component/side-bar-user/componenets/side-bar-student-item';
import { UserPageProfile } from '../pages/profile/user-page-profile';
import { UserPageAcademic } from '../pages/user-page-programms/user-page-academic';
import { UserPageDocs } from '../pages/docs/user-page-docs';
import { UserPagePayments } from '../pages/user-page-payments';
import { UserPagePermissions } from '../pages/user-page-permissions/user-page-permissions';
import { SideBarAdministration } from '../../../component/side-bar-user/side-bar-administration';
import { UserPagePermission2 } from '../pages/user-page-permission2/user-page-permission2';

interface UserPageAdministrationDatamodel {
  user: UserSummaryType;
}
export const UserPageAdministration: React.FC<
  UserPageAdministrationDatamodel
> = ({ user }) => {
  const [itemSelectedType, setItemSelectedType] =
    useState<StudentSideBarItemType>(StudentSideBarItemType.PROFILE);

  const getElementItem = (itemType: StudentSideBarItemType) => {
    switch (itemType) {
      case StudentSideBarItemType.PROFILE:
        return <UserPageProfile user={user} />;
      case StudentSideBarItemType.ACADEMIC:
        return <UserPageAcademic />;

      case StudentSideBarItemType.DOCS:
        return <UserPageDocs />;
      case StudentSideBarItemType.PAYMENT_SERVICES:
        return <UserPagePayments user={user} />;
      case StudentSideBarItemType.PERMISSIONS:
        return <UserPagePermission2 userId={user.id} />;
    }
  };
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        marginTop: '8px',
      }}
    >
      <SideBarAdministration
        onClick={(type) => {
          setItemSelectedType(type);
        }}
      />
      {getElementItem(itemSelectedType)}
    </div>
  );
};
